import { Client } from '@/common/services/Client';

import type { BillingNoteInput } from '../types/BillingNoteInput';

export async function updateBillingNote(
  billingUuid: string,
  noteUuid: string,
  note: BillingNoteInput,
): Promise<void> {
  await Client.patch<void, BillingNoteInput>({
    body: note,
    endpoint: `/billing/${billingUuid}/notes/${noteUuid}`,
  });
}
